import React, { useEffect, useState } from "react";
import Row from "canvas-core-react/lib/Row";
import Grid from "canvas-core-react/lib/Grid";
import Column from "canvas-core-react/lib/Column";
import TextField from "canvas-core-react/lib/TextField";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import useApi from "../../../hooks/useApi";
import MainTemplate from "../../mainTemplate";
import Modal from "../../../utils/customModal";
import { getRoles } from "../../../../Redux/reducer/session";
import { EXECUTE, MOD_DISCONT_PROV } from "../../../../permissions";
import {
  loadingHtml,
  moduleAction,
  sucessInfoModal,
} from "../../../utils/functions";

export const format = (data) => {
  let detail = (
    <>
      <p>Se presentaron los siguientes errores:</p>
      <ul>
        {data?.details?.map(({ message }, key) => (
          <li key={`res-${key}`}>{message}</li>
        ))}
      </ul>
    </>
  );

  if (data?.totalLines === data?.totalLinesOk) {
    detail = <p>La operación fue realizada con éxito.</p>;
  }
  return detail;
};

const ProviderDetailInfo = () => {
  const { t, i18n } = useTranslation();
  const { getApiCAll, cancellCall, postApiCAll } = useApi();
  const { companyId, requestType, currency } = useParams();
  const history = useHistory();
  const [data, setData] = useState({});
  const roles = useSelector((state) => getRoles(state));
  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });

  useEffect(() => {
    fetchData();
    return cancellCall;
  }, []);

  const { buttons, accountDetailsLabel, NA } = {
    buttons: t("general.buttons", { returnObjects: true }),
    accountDetailsLabel: t("general.accountDetails", { returnObjects: true }),
    NA: t("general.labels.na"),
  };

  const fetchData = async () => {
    setModal({ show: true, content: loadingHtml(), onClose: undefined });

    try {
      const response = await getApiCAll(
        `/providers/addition-account-detail/company/${companyId}/${requestType}/${currency}`
      );

      const { data } = response.data;
      setData(data);
      closeModal();
    } catch (e) {
      console.error(e);

      setModal({
        show: true,
        onClose: () => history.push("/providerSite/relations"),
        content: sucessInfoModal(
          "Perfil de cuentas",
          "Ha ocurrido un error inesperado, favor intente mas tarde",
          {
            formBtn: {
              text: "Cerrar",
              action: () => history.push("/providerSite/relations"),
            },
          }
        ),
      });
    }
  };

  const closeModal = () => {
    setModal({ show: false, content: null, onClose: undefined });
  };

  const getProfile = () => {
    return data.provider?.modifyAccount[0]?.accountId === null
      ? newAccount()
      : modifyAccount();
  };

  const getLabel = (label, status) => {
    return i18n.language === "en"
      ? `${accountDetailsLabel.status[status]} ${label}`
      : `${label} ${accountDetailsLabel.status[status]} `;
  };

  const modifyAccount = () => {
    return (
      <>
        <Column lg={6} md={6}>
          <Row nested>
            <Column lg={6}>
              <TextField
                disabled
                id="accountTypeCurrent"
                name="accountTypeCurrent"
                label={getLabel(accountDetailsLabel.accountType, "current")}
                value={data.provider?.accounts[0]?.accountType || NA}
              />
            </Column>
            <Column lg={6}>
              <TextField
                disabled
                id="accountType"
                name="accountType"
                label={getLabel(accountDetailsLabel.accountType, "new")}
                value={data.provider?.modifyAccount[0]?.accountType || NA}
              />
            </Column>
            <Column lg={6}>
              <TextField
                disabled
                id="accountNumberCurrent"
                name="accountNumberCurrent"
                label={getLabel(accountDetailsLabel.accountNumber, "current")}
                value={data.provider?.accounts[0]?.accountNumber || NA}
              />
            </Column>
            <Column lg={6}>
              <TextField
                disabled
                id="accountNumber"
                label={getLabel(accountDetailsLabel.accountNumber, "new")}
                name="accountNumber"
                value={data.provider?.modifyAccount[0]?.accountNumber || NA}
              />
            </Column>
            <Column lg={6}>
              <TextField
                disabled
                id="accountIntermediaryBankCurrent"
                name="accountIntermediaryBankCurrent Actual"
                label={getLabel(accountDetailsLabel.destinationBank, "current")}
                value={
                  data.provider?.accounts[0]?.accountIntermediaryBank || NA
                }
              />
            </Column>
            <Column lg={6}>
              <TextField
                disabled
                id="accountIntermediaryBank"
                name="accountIntermediaryBank"
                label={getLabel(accountDetailsLabel.destinationBank, "new")}
                value={
                  data.provider?.modifyAccount[0]?.accountIntermediaryBank || NA
                }
              />
            </Column>
          </Row>
        </Column>
        <Column lg={6} md={6}>
          <Row nested>
            <Column lg={6}>
              <TextField
                disabled
                id="bicDestinationBankCurrent"
                name="bicDestinationBankCurrent"
                label={getLabel(
                  accountDetailsLabel.bicDestinationBank,
                  "current"
                )}
                value={data.provider?.accounts[0]?.bicDestinationBank || NA}
              />
            </Column>
            <Column lg={6}>
              <TextField
                disabled
                id="bicDestinationBank"
                name="bicDestinationBank"
                label={getLabel(accountDetailsLabel.bicDestinationBank, "new")}
                value={
                  data.provider?.modifyAccount[0]?.bicDestinationBank || NA
                }
              />
            </Column>
            <Column lg={6}>
              <TextField
                disabled
                id="bicIntermediaryBankCurrent"
                name="bicIntermediaryBankCurrent"
                label={getLabel(
                  accountDetailsLabel.bicIntermediaryBank,
                  "current"
                )}
                value={data.provider?.accounts[0]?.bicIntermediaryBank || NA}
              />
            </Column>
            <Column lg={6}>
              <TextField
                disabled
                id="bicIntermediaryBank"
                name="bicIntermediaryBank"
                label={getLabel(accountDetailsLabel.bicIntermediaryBank, "new")}
                value={
                  data.provider?.modifyAccount[0]?.bicIntermediaryBank || NA
                }
              />
            </Column>
            <Column lg={6}>
              <TextField
                disabled
                label={accountDetailsLabel.currency}
                id="accountCurrencyCurrent"
                name="accountCurrencyCurrent"
                style={{ marginTop: "20px" }}
                value={data.provider?.accounts[0]?.accountCurrency || NA}
              />
            </Column>
          </Row>
        </Column>
      </>
    );
  };

  const newAccount = () => {
    return (
      <>
        <Column lg={5} md={5}>
          <TextField
            disabled
            id="accountType"
            label={t("providers.detail.accountType")}
            value={t(
              `general.paymethods.${data.provider?.modifyAccount[0]?.accountType}` ||
                NA
            )}
          />
        </Column>
        <Column lg={5} md={5}>
          <TextField
            disabled
            id="bicDestinationBank"
            label={t("providers.detail.bicDestinationBank")}
            value={data.provider?.modifyAccount[0]?.bicDestinationBank || NA}
          />
        </Column>

        <Column lg={5} md={5}>
          <TextField
            disabled
            id="accountNumber"
            label={t("providers.detail.accountNumber")}
            value={data.provider?.modifyAccount[0]?.accountNumber || NA}
          />
        </Column>
        <Column lg={5} md={5}>
          <TextField
            disabled
            id="bicIntermediaryBank"
            label={t("providers.detail.bicIntermediaryBank")}
            value={data.provider?.modifyAccount[0]?.bicIntermediaryBank || NA}
          />
        </Column>

        <Column lg={5} md={5}>
          <TextField
            disabled
            id="bicAccountIntermediaryBank"
            label={t("providers.detail.bicAccountIntermediaryBank")}
            value={
              data.provider?.modifyAccount[0]?.bicAccountIntermediaryBank || NA
            }
          />
        </Column>
        <Column lg={5} md={5}>
          <TextField
            disabled
            id="currency"
            label={t("providers.detail.currency")}
            value={data.provider?.modifyAccount[0]?.currency || NA}
          />
        </Column>
      </>
    );
  };

  const getModalResponse = (data) => {
    const content = sucessInfoModal(
      "Adiciones/Modificaciones",
      format(data.data),
      {
        formBtn: { text: "Continuar", action: closeAndReset },
      }
    );

    setModal({
      show: true,
      content,
      onClose: closeAndReset,
    });
  };

  const closeAndReset = () => {
    setModal({ show: false, content: null, onClose: undefined });
    history.push("/providers");
  };

  const approveOrReject = (approve) => {
    const elements = [{ approve, id: data.provider?.modifyAccount[0]?.id }];
    doApproveOrReject(elements);
  };

  const doApproveOrReject = async (data) => {
    setModal({ show: true, content: loadingHtml(), onClose: undefined });

    try {
      const response = await postApiCAll(
        `providers/additions-modifications-accouts-csa/approve-or-rejected`,
        data,
        {}
      );

      setModal({ show: false, content: null, onClose: undefined });
      getModalResponse(response.data);
    } catch (error) {
      console.error(error);

      const content = sucessInfoModal(
        t("providers.accounts.modal.successTitle"),
        error.response.data.notifications[0].description,
        { formBtn: { text: "Cerrar", action: closeModal } }
      );

      setModal({ show: true, content, onClose: closeModal });
    }
  };

  return (
    <>
      <MainTemplate className="">
        <div className="profile">
          <h3>{t("providers.detail.generalInformation")}</h3>
          <Grid fluid={true}>
            <Row className="spacing-column" justifyContent="spaceBetween">
              <Column lg={5} md={5}>
                <TextField
                  disabled
                  id="name"
                  label={t("providers.manual.form.name.label")}
                  value={data?.companyName || ""}
                />
              </Column>
              <Column lg={5} md={5}>
                <TextField
                  id="id"
                  disabled
                  label={t("providers.manual.form.id.label")}
                  value={data?.businessId || ""}
                />
              </Column>
            </Row>
            <Row justifyContent="spaceBetween">
              <Column lg={5} md={5}>
                <TextField
                  disabled
                  id="requestType"
                  label={t("providers.detail.requestType")}
                  value={t(
                    `general.relationTypes_detail.${data?.provider?.requestType}` ||
                      ""
                  )}
                />
              </Column>
              <Column lg={5} md={5}>
                <TextField
                  disabled
                  id="statusRequest"
                  label={t("providers.detail.statusRequest")}
                  value={t(
                    `general.inviteStates.${data?.provider?.invitationStatus}` ||
                      ""
                  )}
                />
              </Column>
            </Row>
          </Grid>
          <h3>{t("providers.detail.titleAccountSettlement")}</h3>
          <Grid fluid>
            <Row className="spacing-column" justifyContent="spaceBetween">
              {getProfile()}
            </Row>
          </Grid>
          <div className="form-actions clearfix">
            <SecondaryButton onClick={() => history.push("/providers")}>
              {buttons.back}
            </SecondaryButton>
            {moduleAction(roles, MOD_DISCONT_PROV, EXECUTE) &&
            "MODIFICATION" === requestType ? (
              <>
                <SecondaryButton onClick={() => approveOrReject(false)}>
                  {buttons.rejected}
                </SecondaryButton>
                <SecondaryButton onClick={() => approveOrReject(true)}>
                  {buttons.approve}
                </SecondaryButton>
              </>
            ) : null}
          </div>
        </div>
      </MainTemplate>
      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
    </>
  );
};

export default ProviderDetailInfo;
